import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { constants } from '../../utitlity/constant';
import { QuestionBase } from '../question-base';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl, ControlContainer, NgForm } from '@angular/forms';
import { SelectItem } from 'primeng/primeng';

@Component({
    selector: 'ntb-multi-select-dropdown',
    template: require('./multi-select-dropdown.component.html'),
    styles: [require('./multi-select-dropdown.component.css')],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class MultiSelectDropdownComponent implements OnInit {
    @Input() question: any;
    @Input() questions: any = [];
    @Input() form: NgForm;
    selectedItems: SelectItem[];
    // @Input() prefillData: any;
    fieldModel: any;
    @Output() fieldChange = new EventEmitter<any>();
    // @Output() onNumberChange: EventEmitter<any> = new EventEmitter<any>();
    constructor() { }
    dropDownArr: Array<{code,name}>
    ngOnInit() {
        // this.getDropdownValue();
    }
    onChange(e) { 
        const LIMIT_NUMBER = 2;
         if (e.value.length > LIMIT_NUMBER)
          { e.value.pop(); } }


          dropDownVisible(){
            let depField = this.question['depCountryField']
            if(this.form.value.field && this.form.value.field[depField]){
                let depFieldObj = this.form.value.field[depField];
                let depFieldKeys =[] ;
                if(depFieldObj instanceof Array){
                  depFieldKeys = depFieldObj.map((field)=>field.code);
                }
    
                this.dropDownArr = this.question.dataValues.filter((data)=>{
                    let result;
                    if(depFieldObj instanceof Array){
                       return depFieldKeys.indexOf(data.code) == -1;
                    }  else {
                        return  data.code != this.form.value.field[depField].code
                    }
                })
               return;
            }
            this.dropDownArr = this.question.dataValues;
        }
    


    getDropdownValue(value) {
        if (this.question.hasOwnProperty('isFirstTimeHide')) {
            this.question.isFirstTimeHide = [];
        }
        this.fieldChange.emit(this.question);


    }


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/lodash/lodash.js!./~/tslint-loader!./src/app/components/multi-select-dropdown.component/multi-select-dropdown.component.ts